import React from 'react';
import css from './OurCategories.module.css';

import firstCard from '../../../../../assets/School-boy-studying.gif';
import secondCard from '../../../../../assets/Best-teacher-online.gif';
import thirdCard from '../../../../../assets/Read-Quran.gif';
import fourthCard from '../../../../../assets/News-Reporter-Typewriter.gif';
import fifthCard from '../../../../../assets/Children-sitting in-Classroom.gif';
import { FormattedMessage, injectIntl, intlShape } from '../../../../../util/reactIntl';

const categories = [
  {
    name: 'kids',
    titleId: "OurCategories.category1.title",
    descriptionId: "OurCategories.category1.description",
    image: firstCard,
    bg: "#FFF4E1",
  },
  {
    name: 'msa',
    titleId: "OurCategories.category2.title",
    descriptionId: "OurCategories.category2.description",
    image: secondCard,
    bg: "#FFF9EE",
  },
  {
    name: 'school',
    titleId: "OurCategories.category3.title",
    descriptionId: "OurCategories.category3.description",
    image: thirdCard,
    bg: "#FFF9EE",
  },
  {
    name: 'work',
    titleId: "OurCategories.category4.title",
    descriptionId: "OurCategories.category4.description",
    image: fourthCard,
    bg: "#FFF4E1",
  },
  {
    name: 'quranic',
    titleId: "OurCategories.category5.title",
    descriptionId: "OurCategories.category5.description",
    image: fifthCard,
    bg: "#FFF9EE",
  },
];


function OurCategories() {
  return (
    <section className={css.section}>
      <div className={css.header}>
        <h2 className={css.title}>
          <FormattedMessage id="OurCategories.title" />
        </h2>
        <p className={css.subtitle}>
          <FormattedMessage id="OurCategories.subtitle" />
        </p>
      </div>

      <div className={css.grid}>
        {categories.map((cat, i) => (
          <div
            key={i}
            className={`${css.card} ${css[cat.name]}`}
            style={{ backgroundColor: cat.bg }}
          >
            <div className={css.cardContent}>
              <h3 className={css.cardTitle}>
                <FormattedMessage id={cat.titleId} />
              </h3>
              <p className={css.cardDesc}>
                <FormattedMessage id={cat.descriptionId} />
              </p>
            </div>
            {cat.image && <img src={cat.image} alt="category" className={css.cardImage} />}
          </div>
        ))}
      </div>
    </section>
  )
}

export default OurCategories